<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
          v-if="scope.row.status == 'UNDER_WAY'"
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >禁用</el-button>
          <el-button
          v-if="scope.row.status == 'DISABLE'"
            type="success"
            size="small"
            plain
            @click.stop="handleAble(scope.row,scope.index)"
          >启用</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleDetail(scope.row,scope.index)"
          >查看</el-button>
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="success"
            size="small"
            plain
            @click.stop="func(scope.row)"
          >查看明细</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="brandNameForm"
        >
          <el-select
            v-model="data.brand"
            placeholder="请选择品牌"
            required
            @change="changeBrandName"
          >
            <el-option
              v-for="brand in brands"
              :key="brand.id"
              :label="brand.name"
              :value="brand.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="productTypeForm"
        >
          <el-select
            v-model="data.productType"
            placeholder="请选择产品售卖渠道"
            required
            @change="chooseproductType"
          >
            <el-option
              v-for="item in productTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="firstClassifyNameForm"
        >
          <el-select
            v-model="data.classify"
            placeholder="请选择商品一级分类"
            required
            @change="chooseSecondClassify"
          >
            <el-option
              v-for="classify in classifies"
              :key="classify.id"
              :label="classify.name"
              :value="classify.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="secondClassifyNameForm"
        >
          <el-select
            v-model="data.secondClassify"
            placeholder="请选择商品二级分类"
            required
            @change="findProductByClassify"
          >
            <el-option
              v-for="secondClassify in secondClassifies"
              :key="secondClassify.id"
              :label="secondClassify.name"
              :value="secondClassify.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="fullDiscountForm"
        >
          <el-radio-group v-model="data.fullDiscount">
            <el-radio
              @change="changeFullDiscount"
              label="YES"
            >是</el-radio>
            <el-radio
              @change="changeFullDiscount"
              label="NO"
            >否</el-radio>
          </el-radio-group>
        </template>
        <template
          slot-scope="scope"
          slot="goodsIdForm"
        >
          <el-select
            v-model="goodId"
            placeholder="请选择商品"
            clearable
            @change="changeGoodsId"
          >
            <el-option
              v-for="goods in goodies"
              :key="goods.id"
              :label="goods.goodsName"
              :value="goods.id"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="couponNameForm"
        >
          <el-input
            v-model="data.couponName"
            @change="changeCouponName"
            placeholder="请输入优惠券名称"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="useCustomerTypeForm"
        >
          <el-select
            v-model="data.useCustomerType"
            placeholder="请选择优惠券使用用户"
            required
            @change="changeUseCustomerType"
          >
            <el-option
              v-for="clientType in clientTypes"
              :key="clientType.value"
              :label="clientType.label"
              :value="clientType.value"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="promoteCustomerTypeForm"
        >
          <el-select
            v-model="data.promoteCustomerType"
            placeholder="请选择优惠券使用用户"
            required
            value-key="value"
          >
            <el-option
              v-for="clientType in clientTypes"
              :key="clientType.value"
              :label="clientType.label"
              :value="clientType"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="scope"
          slot="commissionRateForm"
        >
          <el-input
            v-model="data.commissionRate"
            placeholder="请输入佣金比例"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="fullMoneyForm"
        >
          <el-input
            v-model="data.fullMoney"
            @change="changeFullMoney"
            placeholder="请输入满多少减"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="deductionForm"
        >
          <el-input
            v-model="data.deduction"
            @change="changeDeduction"
            placeholder="请输入减多少"
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="addUpForm"
        >
          <el-radio-group v-model="addUp">
            <el-radio label="NO">否</el-radio>
            <el-radio label="YES">是</el-radio>
          </el-radio-group>
        </template>
        <template
          slot-scope="scope"
          slot="expiryDateForm"
        >
          <el-radio-group
            :disabled="isAbled"
            v-model="data.expiryDate"
          >
            <el-radio
              @change="changeExpiryDate"
              label="YES"
            >是</el-radio>
            <el-radio
              @change="changeExpiryDate"
              label="NO"
            >否</el-radio>
          </el-radio-group>
        </template>
        <template
          slot-scope="scope"
          slot="startTimeForm"
        >
          <el-date-picker
            v-model="startTime"
            type="datetime"
            @change="changeStartTime"
            :disabled="isAbled"
            placeholder="选择日期时间"
          ></el-date-picker>
        </template>
        <template
          slot-scope="scope"
          slot="endTimeForm"
        >
          <el-date-picker
            v-model="endTime"
            type="datetime"
            :disabled="isAbled"
            @change="changeEndTime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </template>
        <template
          slot-scope="scope"
          slot="status"
        >
          <el-tag
            v-for="obj of couponStatus"
            :key="obj.value"
            v-if="obj.value == scope.row.status"
            :type="getCouponStatus(scope.row.status)"
          >{{obj.label}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="addUp1"
        >
          <el-tag
            v-for="obj of yesOrNos"
            :key="obj.value"
            v-if="obj.value == scope.row.addUp1"
          >{{obj.label}}</el-tag>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { productCouponOption } from "@/const/salesCloud/productCouponOption";
import {
  findProductCoupon,
  delCoupon,
  ableCoupon,
  editCoupon,
  findProductByClassify,
  addProductCoupon,
  findBrand,
  chooseSecondClassify,
  findClassify
} from "@/api/salesCloud/productCoupon";
import { DIC } from "@/const/dic";

export default {
  name: "productCoupon",
  data() {
    return {
      tableOption: productCouponOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      brands: [],
      classifies: [],
      secondClassifies: [],
      clientTypes: DIC.CLIENT_TYPE,
      goodies: [],
      data: {},
      goodId: "",
      isAbled: false,
      productTypes: DIC.PRODUCT_ORDER_TYPE,
      couponStatus: DIC.PRODUCT_COUPON_STATUS,
      yesOrNos: DIC.YES_NO,
      addUp: "NO",
      startTime: null,
      endTime: null
    };
  },
  created() {
    this.data.fullDiscount = "NO";
    this.data.expiryDate = "NO";
    findBrand().then(res => {
      let data = JSON.parse(res.data);
      this.brands = data.rows;
    });
    findClassify().then(res => {
      let data = JSON.parse(res.data);
      this.classifies = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"]),
    getCouponStatus() {
      return function(status) {
        if (status == "UNDER_WAY") {
          return "success";
        } else if (status == "NOT_BEGIN") {
          return "info";
        } else if (status == "OVER") {
          return "danger";
        }else{
          return "warning";
        }
      };
    }
  },
  props: [],
  methods: {
    chooseproductType() {
      console.log(this.data);
      this.$refs.crud.$refs.tableForm.form.productType = this.data.productType;
    },
    changeGoodsId() {
      console.log(this.data);
    },
    changeCouponName() {
      this.$refs.crud.$refs.tableForm.form.couponName = this.data.couponName;
    },
    changeUseCustomerType() {
      this.$refs.crud.$refs.tableForm.form.useCustomerType = this.data.useCustomerType;
    },
    changeFullMoney() {
      this.$refs.crud.$refs.tableForm.form.fullMoney = this.data.fullMoney;
    },
    changeDeduction() {
      this.$refs.crud.$refs.tableForm.form.deduction = this.data.deduction;
    },
    changeBrandName() {
      this.$refs.crud.$refs.tableForm.form.brandName = this.data.brand;
    },
    changeFirstClassifyName() {
      this.$refs.crud.$refs.tableForm.form.firstClassifyName = this.data.classify;
    },
    changeSecondClassifyName() {
      this.$refs.crud.$refs.tableForm.form.secondClassifyName = this.data.secondClassify;
    },
    changeStartTime() {
      this.$refs.crud.$refs.tableForm.form.startTime = this.startTime;
    },
    changeEndTime() {
      console.log(this.endTime);
      this.$refs.crud.$refs.tableForm.form.endTime = this.endTime;
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findProductCoupon(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findProductCoupon(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findProductCoupon(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findProductCoupon(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    clean() {
      this.data = {};
      this.isAbled = false;
      //   this.data.startTime = null;
      //   this.data.endTime = null;
    },
    handleAdd() {
      //   this.data=[]
      this.clean();
      this.data.fullDiscount = "NO";
      this.data.expiryDate = "NO";
      this.goodId = "";
      if (this.startTime) {
        this.startTime = "";
      }
      if (this.endTime) {
        this.endTime = "";
      }
      this.changeFullDiscount();
      this.changeExpiryDate();
      this.$refs.crud.rowAdd();
    },
    handleDetail(row, index) {
      this.handleList();
      this.clean();
      console.log(row);
      console.log(this.data);
      this.isAbled = true;
      this.data = row;
      // 优惠券名称回显
      this.data.couponName = row.couponName;
      // 优惠券使用用户回显
      this.data.useCustomerType = row.useCustomerType;
      //满减回显
      this.data.fullMoney = row.fullMoney;
      this.data.deduction = row.deduction;
      // 商品品牌分类回显
      this.data.brand = row.brandId;
      // 是否累计回显
      this.addUp = row.addUp1;
      //一级分类回显
      this.data.classify = row.firstClassifyId;
      //二级分类回显
      chooseSecondClassify(this.data.classify).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
      this.data.secondClassify = row.secondClassifyId;
      //优惠券产品回显
      let obj = {};
      obj.firstClassifyId = this.data.classify;
      obj.secondClassifyId = this.data.secondClassify;
      findProductByClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.goodies = data;
        //验证值通过
        this.$refs.crud.$refs.tableForm.form.brandName = row.brandId;
        this.$refs.crud.$refs.tableForm.form.firstClassifyName = row.classify;
        this.$refs.crud.$refs.tableForm.form.secondClassifyName =
          row.secondClassify;
        this.$refs.crud.$refs.tableForm.form.startTime = this.startTime;
        this.$refs.crud.$refs.tableForm.form.endTime = this.endTime;
      });
      this.goodId = row.goodsId;
      //开始时间回显
      this.startTime = row.startTime1;
      this.endTime = row.endTime1;
      // 是否全分类回显
      this.data.fullDiscount = row.fullDiscount;
      this.changeFullDiscount();
      //优惠券是否长期有效
      this.data.expiryDate = row.expiryDate;
      this.changeExpiryDate();
      this.$refs.crud.rowView(row, index);
    },
    handleEdit(row, index) {
      this.clean();
      console.log(row);
      console.log(this.data);
      this.isAbled = true;
      this.data = row;
      // 优惠券名称回显
      this.data.couponName = row.couponName;
      // 优惠券使用用户回显
      this.data.useCustomerType = row.useCustomerType;
      //满减回显
      this.data.fullMoney = row.fullMoney;
      this.data.deduction = row.deduction;
      // 商品品牌分类回显
      this.data.brand = row.brandId;
      // 是否累计回显
      this.addUp = row.addUp1;

      //一级分类回显
      this.data.classify = row.firstClassifyId;
      //二级分类回显
      chooseSecondClassify(this.data.classify).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
      this.data.secondClassify = row.secondClassifyId;
      //优惠券产品回显
      let obj = {};
      obj.firstClassifyId = this.data.classify;
      obj.secondClassifyId = this.data.secondClassify;
      findProductByClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.goodies = data;
        //验证值通过
        this.$refs.crud.$refs.tableForm.form.brandName = row.brandId;
        this.$refs.crud.$refs.tableForm.form.firstClassifyName = row.classify;
        this.$refs.crud.$refs.tableForm.form.secondClassifyName =
          row.secondClassify;
        this.$refs.crud.$refs.tableForm.form.startTime = this.startTime;
        this.$refs.crud.$refs.tableForm.form.endTime = this.endTime;
      });
      this.goodId = row.goodsId;
      //开始时间回显
      this.startTime = row.startTime1;
      this.endTime = row.endTime1;
      // 是否全分类回显
      this.data.fullDiscount = row.fullDiscount;
      this.changeFullDiscount();
      //优惠券是否长期有效
      this.data.expiryDate = row.expiryDate;
      this.changeExpiryDate();

      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findProductCoupon(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log("data:" + JSON.stringify(this.data));
      this.data.useCustomerType = this.data.useCustomerType;
      // this.data.promoteCustomerType=this.data.promoteCustomerType.value
      this.data.brandId = this.data.brand;
      this.data.firstClassifyId = this.data.classify;
      this.data.secondClassifyId = this.data.secondClassify;
      if (null != this.goodId) {
        this.data.goodsId = this.goodId;
      }
      this.data.addUp = this.addUp;
      if (null != this.startTime && undefined != this.startTime) {
        this.data.startTime = new Date(this.startTime).getTime();
        if (this.startTime < new Date().getTime()) {
          this.$message({
            showClose: true,
            message: "优惠券的开始时间不能早于当前时间",
            type: "error"
          });
          done();
          return;
        }
      }
      if (null != this.endTime && undefined != this.endTime) {
        this.data.endTime = new Date(this.endTime).getTime();
      }
      let data = this.data;

      addProductCoupon(data)
        .then(response => {
          this.data = {};
          this.data.expiryDate = "NO";
          this.data.fullDiscount = "NO";

          for (let i = 0; i < productCouponOption.column.length; i++) {
            if (productCouponOption.column[i].prop == "startTime") {
              var startTimeIndex = i;
            } else if (productCouponOption.column[i].prop == "endTime") {
              var endTimeIndex = i;
            } else if (productCouponOption.column[i].prop == "goodsId") {
              var goodsIdIndex = i;
            }
          }
          productCouponOption.column.filter(item => {
            item.prop == "startTime";
          });
          productCouponOption.column[goodsIdIndex].addVisdiplay = true;
          productCouponOption.column[goodsIdIndex].formsolt = true;
          productCouponOption.column[startTimeIndex].addVisdiplay = true;
          productCouponOption.column[startTimeIndex].formsolt = true;
          productCouponOption.column[endTimeIndex].addVisdiplay = true;
          productCouponOption.column[endTimeIndex].formsolt = true;
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row, index) {
      console.log(row);
      this.$confirm(`是否确认禁用?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delCoupon(row.id).then(res => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "禁用成功",
              type: "success"
            });
            this.handleList();
          });
        })
        .catch(() => {});
    },
    
    /**
     * @title 数据恢复
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleAble(row, index) {
      console.log(row);
      this.$confirm(`是否确认启用?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ableCoupon(row.id).then(res => {
            console.log(res);
            this.$message({
              showClose: true,
              message: "启用成功",
              type: "success"
            });
            this.handleList();
          });
        })
        .catch(() => {});
    },
    
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log("data:" + JSON.stringify(this.data));
      this.data.useCustomerType = this.data.useCustomerType;
      // this.data.promoteCustomerType=this.data.promoteCustomerType.value
      // this.$refs.crud.$refs.tableForm.form.brandName = this.data.brand;
      this.data.brandId = this.data.brand;
      this.data.firstClassifyId = this.data.classify;
      this.data.secondClassifyId = this.data.secondClassify;
      if (null != this.goodId) {
        this.data.goodsId = this.goodId;
      }
      this.data.addUp = this.addUp;
      if (null != this.startTime && undefined != this.startTime) {
        this.data.startTime = new Date(this.startTime).getTime();
        if (this.startTime < new Date().getTime()) {
          this.$message({
            showClose: true,
            message: "优惠券的开始时间不能早于当前时间",
            type: "error"
          });
          done();
          return;
        }
      }
      if (null != this.endTime && undefined != this.endTime) {
        this.data.endTime = new Date(this.endTime).getTime();
      }
      let data = this.data;
      editCoupon(data)
        .then(response => {
          this.data = {};
          this.data.expiryDate = "NO";
          this.data.fullDiscount = "NO";
          for (let i = 0; i < productCouponOption.column.length; i++) {
            if (productCouponOption.column[i].prop == "startTime") {
              var startTimeIndex = i;
            }
            if (productCouponOption.column[i].prop == "endTime") {
              var endTimeIndex = i;
            }
            if (productCouponOption.column[i].prop == "goodsId") {
              var goodsIdIndex = i;
            }
          }
          productCouponOption.column[goodsIdIndex].addVisdiplay = true;
          productCouponOption.column[goodsIdIndex].formsolt = true;
          productCouponOption.column[startTimeIndex].addVisdiplay = true;
          productCouponOption.column[startTimeIndex].formsolt = true;
          productCouponOption.column[endTimeIndex].addVisdiplay = true;
          productCouponOption.column[endTimeIndex].formsolt = true;
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    func(row) {
      this.$router.push({
        name: "商品优惠券明细",
        path: "/sales/productCouponDetail",
        query: { id: row.id }
      });
    },
    downloadQr1() {
      window.open(
        "http://192.168.3.100:5200/joins-sales-cloud/v1/qr/batchDownloadQrCode"
      );
    },
    chooseSecondClassify() {
      this.changeFirstClassifyName();
      this.data.secondClassify = "";
      this.goodId = "";
      chooseSecondClassify(this.data.classify).then(res => {
        let data = JSON.parse(res.data);
        this.secondClassifies = data;
      });
    },
    changeFullDiscount() {
      for (let i = 0; i < productCouponOption.column.length; i++) {
        if (productCouponOption.column[i].prop == "goodsId") {
          var goodIdIndex = i;
        }
      }
      if (this.data.fullDiscount == "YES") {
        productCouponOption.column[goodIdIndex].addVisdiplay = false;
        productCouponOption.column[goodIdIndex].editVisdiplay = false;
        productCouponOption.column[goodIdIndex].viewVisdiplay = false;
        productCouponOption.column[goodIdIndex].formsolt = false;
      } else {
        productCouponOption.column[goodIdIndex].addVisdiplay = true;
        productCouponOption.column[goodIdIndex].editVisdiplay = true;
        productCouponOption.column[goodIdIndex].viewVisdiplay = true;
        productCouponOption.column[goodIdIndex].formsolt = true;
      }
    },
    changeExpiryDate() {
      console.log(productCouponOption.column);
      for (let i = 0; i < productCouponOption.column.length; i++) {
        if (productCouponOption.column[i].prop == "startTime") {
          var startTimeIndex = i;
        } else if (productCouponOption.column[i].prop == "endTime") {
          var endTimeIndex = i;
        }
      }
      if (this.data.expiryDate == "YES") {
        this.startTime = null;
        this.endTime = null;
        productCouponOption.column[startTimeIndex].addVisdiplay = false;
        productCouponOption.column[startTimeIndex].editVisdiplay = false;
        productCouponOption.column[startTimeIndex].viewVisdiplay = false;
        productCouponOption.column[startTimeIndex].formsolt = false;
        productCouponOption.column[endTimeIndex].addVisdiplay = false;
        productCouponOption.column[endTimeIndex].editVisdiplay = false;
        productCouponOption.column[endTimeIndex].viewVisdiplay = false;
        productCouponOption.column[endTimeIndex].formsolt = false;
      } else {
        productCouponOption.column[startTimeIndex].addVisdiplay = true;
        productCouponOption.column[startTimeIndex].editVisdiplay = true;
        productCouponOption.column[startTimeIndex].viewVisdiplay = true;
        productCouponOption.column[startTimeIndex].formsolt = true;
        productCouponOption.column[endTimeIndex].addVisdiplay = true;
        productCouponOption.column[endTimeIndex].editVisdiplay = true;
        productCouponOption.column[endTimeIndex].viewVisdiplay = true;
        productCouponOption.column[endTimeIndex].formsolt = true;
      }
    },
    findProductByClassify() {
      this.changeSecondClassifyName();
      this.goodId = "";
      let obj = {};
      // obj.type = this.data.productType;
      obj.firstClassifyId = this.data.classify;
      obj.secondClassifyId = this.data.secondClassify;
      findProductByClassify(obj).then(res => {
        let data = JSON.parse(res.data);
        this.goodies = data;
      });
    },
    test() {}
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
